import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.scss";

const NotFound = () => {
  return (
    <div className="not-found">
      <div className="content">
        <h1>404</h1>
        <p>Oops, the page you're looking for doesn't exist.</p>
        <Link to="/">Go Home</Link>
      </div>
    </div>
  );
};

export default NotFound;
